import { render, staticRenderFns } from "./ArticleDoctorEditor.vue?vue&type=template&id=36412cc2&scoped=true"
import script from "./ArticleDoctorEditor.vue?vue&type=script&lang=js"
export * from "./ArticleDoctorEditor.vue?vue&type=script&lang=js"
import style0 from "./ArticleDoctorEditor.vue?vue&type=style&index=0&id=36412cc2&prod&scoped=true&lang=css"
import style1 from "./ArticleDoctorEditor.vue?vue&type=style&index=1&id=36412cc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36412cc2",
  null
  
)

export default component.exports